import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ROUTE_PATHS } from '@shared/constants/routes.constant';

export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: ROUTE_PATHS.LANDING,
    pathMatch: 'full',
  },
  {
    path: ROUTE_PATHS.LANDING,
    loadChildren: () =>
      import('./feature/landing/landing.module').then((m) => m.LandingModule),
  },
  {
    path: ROUTE_PATHS.AUTH,
    loadChildren: () =>
      import('./feature/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: ROUTE_PATHS.LOADING,
    loadComponent: () =>
      import('./feature/loading/sing-in-loader.component').then(
        (m) => m.SignInLoaderComponent
      ),
  },
  {
    path: ROUTE_PATHS.ADMIN,
    loadChildren: () =>
      import('./feature/admin/admin.module').then((m) => m.AdminModule),
    // TODO: re-enable guards once API permissions are resolved
    // canActivate: [AuthGuard, MsalGuard],
    // canActivateChild: [AuthGuard],
  },
  {
    path: 'error',
    loadChildren: () =>
      import('./feature/error/error.module').then((m) => m.ErrorModule),
  },
  {
    path: '**',
    redirectTo: 'error/404',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, {
    enableViewTransitions: true,
    
  })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
